<template>
  <div class="d-flex flex-column flex-grow-1">
    <label class="cursor-pointer" @click="onExpandClick">
      <span>{{ label }}</span>
      <b-icon :icon="innerExpanded ? 'caret-down-fill' : 'caret-right-fill'" />
    </label>

    <div v-if="innerExpanded">
      <div v-for="(item, index) of items" :key="item[itemKey]" class="list-builder-field my-2">
        <translated-field :value="item[itemText]" class="py-2 px-4" @blur="(value) => onBlur(index, value)" />

        <b-button
          variant="outline-danger"
          class="mb-2 list-builder-delete-button"
          @click="() => onDeleteClick(item[itemKey])"
        >
          <b-icon icon="trash" aria-hidden="true" />
        </b-button>
      </div>

      <div class="list-builder-field my-2">
        <translated-field :key="newKey" :label="$t('Add New')" class="py-2 px-4" @blur="onNewBlur" />
      </div>
    </div>
  </div>
</template>

<script>
import { v4 as uuid } from 'uuid';

import iconToggle from '@/components/iconToggle/iconToggle';
import IconSelector from '@/components/IconSelector';
import TranslatedField from '@/components/form/TranslatedField';

export default {
  name: 'ListBuilder',

  components: {
    iconToggle,
    IconSelector,
    TranslatedField,
  },

  props: {
    label: {
      type: String,
      default: 'Dynamic list',
    },
    items: {
      type: Array,
      default: null,
    },
    expanded: {
      type: Boolean,
      default: false,
    },
    itemKey: {
      type: String,
      default: 'key',
    },
    itemText: {
      type: String,
      default: 'text',
    },
  },

  data() {
    return {
      innerExpanded: false,
      newKey: Math.random(),
    };
  },

  methods: {
    onBlur(index, value) {
      const prevItem = this.items && this.items[index];
      if (!prevItem) {
        return;
      }

      const pairs = Object.entries(prevItem[this.itemText] || {});
      if (Object.values(value).length !== pairs.length || pairs.some(([key, text]) => value[key] !== text)) {
        this.$emit('update', { [this.itemKey]: prevItem[this.itemKey], [this.itemText]: value });
      }
    },

    onNewBlur(value) {
      if (!Object.values(value).some((text) => !!(text && text.trim()))) {
        return;
      }

      this.$emit('new', { [this.itemKey]: uuid(), [this.itemText]: value });
      this.newKey = Math.random();
    },

    onDeleteClick(key) {
      this.$emit('delete', key);
    },

    onExpandClick() {
      this.innerExpanded = !this.innerExpanded;
      this.$emit('update:expanded', this.innerExpanded);
    },
  },

  watch: {
    expanded: {
      immediate: true,
      handler(next) {
        this.innerExpanded = next;
      },
    },
  },
};
</script>

<style scoped>
.list-builder-field {
  position: relative;
  border: 1px solid white;
  border-radius: 5px;
}

.list-builder-delete-button {
  position: absolute;
  right: 6px;
  top: 6px;
  z-index: 10;
  border-radius: 50%;
  margin-bottom: 0 !important;
  padding: 6px !important;
  font-size: 0.875rem;
}
</style>



// WEBPACK FOOTER //
// src/components/common/ListBuilder.vue